// Custom Vue directive to detect clicks outside an element.
// Uses capture phase to fire before event.stopPropagation() can prevent it.
//
// IMPORTANT: Our app uses teleported overlays/modals (teleport to <body>). Without special
// handling, click-outside listeners attached to elements *behind* an overlay will interpret
// clicks inside the overlay as "outside" and may close parent panels.
const TELEPORTED_OVERLAY_SELECTOR = [
  ".overlay", // GenericComponents/Overlay.vue
  ".slideshow-overlay", // GenericComponents/ImageSlideshowOverlay.vue
  ".modal", // AuthComponents/Modal.vue (and similar)
  ".alertModal",
  ".alert-modal",
].join(",");

const isElement = (value) => typeof Element !== "undefined" && value instanceof Element;

const eventCameFromTeleportedOverlay = (event) => {
  try {
    const path = typeof event?.composedPath === "function" ? event.composedPath() : [];
    return path.some(
      (node) =>
        isElement(node) &&
        typeof node.matches === "function" &&
        node.matches(TELEPORTED_OVERLAY_SELECTOR),
    );
  } catch {
    return false;
  }
};

const elementIsInsideTeleportedOverlay = (el) => {
  try {
    return isElement(el) && typeof el.closest === "function" && el.closest(TELEPORTED_OVERLAY_SELECTOR);
  } catch {
    return false;
  }
};

const ClickOutside = {
  beforeMount: (el, binding) => {
    el.clickOutsideEvent = function (event) {
      if (binding.arg?.skip) return;

      // If the click happened inside a teleported overlay, don't trigger click-outside for
      // elements that are NOT inside that overlay.
      if (!elementIsInsideTeleportedOverlay(el) && eventCameFromTeleportedOverlay(event)) {
        return;
      }

      if (!(el === event.target || el.contains(event.target))) {
        binding.value();
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent, true);
  },
  unmounted: (el) => {
    document.body.removeEventListener("click", el.clickOutsideEvent, true);
  },
};

export default ClickOutside;


  